<template>
  <div
    id="secondFloor"
    v-show="(isFlagLiClass !== null && isFlagLiClass !== '' && isFlagSpanClass !== null)"
    :secondNavItem="secondNavItem"
  >
    <el-row class="header_select">
      <div class="rectangle_copy">
        <div class="shape" @click="IsMyProject">
          <span class="options">{{ appTitle ? appTitle : $t('table.common.thirdNav.myprojects.title') }}</span>
          <i style="display: flex;flex-grow: 1;"></i>
          <img
            style="width: 10px;height: 7px;margin-top: 7px;margin-right: 10px;"
            src="../assets/img/header/btn_arrow_collapse_copy.png"
            alt
          >
        </div>
        <el-collapse-transition>
        <div v-show="this.$store.state.isSearchProject">
          <div class="_div">
            <el-input v-model="search" size="mini" class="hint" :placeholder="$t('table.common.search.placeholder')"/>
            <i @click="searchMyProjects(search)" class="_sprite_class"></i>
          </div>
          <div>
            <ul>
              <li
                @click="myProjectsClick(o.appId)"
                class="search_li"
                v-for=" (o, i) in myProjectsNavItemsClone "
                :key="i"
                v-show="(i < 4)"
              >
                <img class="search_li_img" :src="o.icon" alt>
                <span class="search_li_span">{{ o.projectName ? o.projectName : '未命名專案' }}</span>
              </li>

            </ul>
            <div v-if="!myProjectsNavItemsClone.length && search && isSearchState" class="noSearchResult">
                {{ $t('table.common.secondFloor.search.noData') }}
            </div>
          </div>
        </div>
        </el-collapse-transition>
      </div>
      <div class="bg-purple-dark">
        <span
          v-for="(o, index) in secondNavItem"
          :key="index"
          @click="headerNavMainFunc(o.path)"
          :class="typeof o === 'object' ? isFlagLiClass === o.path ? `spanNavClass _second_floor_span` : '_second_floor_span' : '_second_floor_separated'"
          class="_second_floor_span"
          :style="o.path === 'overView' ? cursorNo : ' ' "
        >{{ typeof o === 'object' ? $t(o.msg) : '|' }}</span>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
    // props: ['secondNavItem'],
    data () {
        return {
            activeIndex: '2',
            dropdown_menu: false,
            search: '',
            routes: [],
            cursorNo: 'cursor:not-allowed;margin-top:17px;',
            myProjectsNavItems: [],
            myProjectsNavItemsClone: [],
            appTitle: '',
            isSearchState: false
            // secondNavWatch: []
        }
    },
    methods: {
        // 专案清单
        myProjectsClick (appId) {
            if (this.isFlagSpanClass === 'appAnalysis') {
                this.$router.push({
                    path: '/echarts',
                    query: {
                        appId
                    }
                })
                this.$store.state.myProjectsSearchId = {
                    key: 'appAnalysis',
                    val: appId
                }
            } else if (this.isFlagSpanClass === 'MyProjectsList') {
                let witchOnePath = this.$router.options.routes.filter(o => o.name === this.isFlagSpanClass)[0].meta.navObj.contains.filter(o => o === this.isFlagLiClass)[0]
                if (witchOnePath) {
                    if (witchOnePath === 'MyProjectsVersion') {
                        this.$router.push({
                            name: witchOnePath
                        })
                    } else {
                        this.$router.push({
                            name: witchOnePath,
                            params: { appId: appId }
                        })
                    }
                    localStorage.setItem('appId', appId)
                    this.$store.state.myProjectsSearchId = {
                        key: witchOnePath,
                        val: appId
                    }
                    this.indexUrl()
                }
            }
        },
        searchMyProjects (val) {
            this.isSearchState = true
            if (!val) {
                return (this.myProjectsNavItemsClone = [])
            }
            this.myProjectsNavItemsClone = this.myProjectsNavItems.filter(i =>
                i.projectName.toLowerCase().match(val.toLowerCase())
            )
        },
        myProjectsNavSearch (type) {
            let path
            this.search = ''
            this.$store.state.isSearchProject = false
            if (type === 'appAnalysis') {
                path = 'developer/app?status=published'
            } else if (type === 'MyProjectsList') {
                path = 'developer/app'
            } else {
                return
            }
            this._api.request('get', path)
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data.data.payload
                        this.myProjectsNavItems = data
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        IsMyProject () {
            let isSearchProject = this.$store.state.isSearchProject
            if (isSearchProject) {
                this.$store.state.isSearchProject = false
                return
            }
            this.$store.state.isSearchProject = true
        },
        headerNavMainFunc (path) {
            // 不显示overView
            if (path === 'overView' || this.isFlagLiClass === path) {
                return
            }
            this.routes.forEach(item => {
                if (item.path === path) {
                    this.navRouterState(item)
                }
            })
        },
        indexUrl () {
            let str = ''
            let appId = ''
            if (this.isFlagSpanClass === 'appAnalysis') {
                str = '?appId='
                let url = window.location.href
                appId = url.substring(url.indexOf(str) + str.length, url.indexOf(str).length)
            } else {
                appId = localStorage.getItem('appId')
            }

            this.myProjectsNavItems.filter(o => o.appId === appId)[0] &&
                (this.appTitle = this.myProjectsNavItems.filter(
                    o => o.appId === appId
                )[0].projectName)
        }
    },
    computed: {
        isFlagLiClass () {
            this.indexUrl()
            return this.$store.state.isFlagLiClass
        },
        isFlagSpanClass () {
            this.myProjectsNavSearch(this.$store.state.isFlagSpanClass)
            return this.$store.state.isFlagSpanClass
        },
        secondNavItem () {
            return this.$store.state.secondNavItem
        }
    },
    watch: {
        search () {
            // 搜索的同时进行数据过滤
            !this.search && (this.isSearchState = false)
            this.searchMyProjects(this.search)
            return this.search
        }
    },
    mounted () {
        let routes = this.$router.options.routes
        this.routes = routes
            .filter(
                item =>
                    item.hasOwnProperty('meta') &&
                    item.meta.hasOwnProperty('navObj')
            )
            .map(item => item.meta.navObj)
    }
}
</script>
<style scoped>
ul {
    padding: 0px;
    margin: 0px;
}
ul li {
    list-style: none;
}
#secondFloor {
    width: 1280px;
    /* position: fixed; */
    /* top: 60px; */
    /* z-index: 2; */
    background-color:#E8F7FC;
    /* box-shadow: 0 1px 0 0 rgba(0, 181, 226, 0.3); */
}
.noSearchResult{
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
    line-height: 22px;
    margin-left: 10px;
}
.header_select::after {
    height: 120px;
}
.el-row {
    height: 60px !important;
    padding-left: 98px;
}
.bg-purple-dark {
    margin-left: 350px;
    display: flex;
}
._second_floor_span {
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.9px;
    color: rgba(51, 51, 51, 0.5);
    margin-top: 17px;
}
._second_floor_span:hover {
    cursor: pointer;
    margin-top: 15px;
}

._second_floor_separated {
    width: 5px;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
    margin: 0px 36px;
    margin-top: 17px;
}

.rectangle_copy {
    width: 256px;
    border-radius: 4px;
    box-shadow: 2px 2px 10px 0 rgba(51, 51, 51, 0.3);
    border: solid 1px rgba(51, 51, 51, 0.2);
    background-color: #ffffff;
    padding: 4px 0px 4px 0px;
    margin-top: 14px;
    position: fixed;
}

.shape {
    width: 256px;
    height: 22px;
    border-radius: 4px;
    display: flex;
}

.options {
    height: 18px;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
    line-height: 22px;
    margin-left: 10px;
}

._div {
    display: inline-block;
    position: relative;
    width: 250px;
    height: 30px;
    border-radius: 4px;
    background-color: #ffffff;
    border-radius: 3px;
    outline: none !important;
    margin-left: 3px;
    margin-top: 2px;
}

._sprite_class {
    display: inline-block;
    width: 15px;
    height: 14px;
    background-image: url('../assets/img/header/filter_search_icon.png');
    position: absolute;
    left: 8px;
    top: 7px;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
}
.search_li_img {
    display: inline-block;
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-right: 6px;
    margin-left: 10px;
}

.search_li {
    margin: 3px 0px;
}
.search_li:hover {
    background-color: rgba(0, 224, 218, 0.05);
}
.search_li_span {
    width: 239px;
    height: 18px;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
}
.spanNavClass {
    /* width: 68px; */
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
}
</style>

<style>
#secondFloor .el-input__inner:focus {
    border: 2px solid rgba(0, 224, 218, 0.5) !important;
}
#secondFloor .el-input--mini .el-input__inner {
    padding-left: 26px !important;
    transition: .2s;
}
</style>
